import axios from "axios";

export const getRates = async (apartmentId) => {
    const url = `/api/v1/user_profile/rms/rates`;
    const res = await axios.get(url, {params: {apartment_id: apartmentId}});
    return res.data;
}

export const updateRate = async (rateId, data) => {
    /*
        * Data is an object like this:
        * {
        *   minPeople: int,
        *   maxPeople: int,
        *   basePeople: int,
        *   priceVariations: [
        *     {
        *       id: string,  // optional, if not present, it is a new price variation
        *       people: int,
        *       percentage: int,
        *     },
        *     ...
        *   ]
        * }
        *
     */
    const url = `/api/v1/user_profile/rms/rates/${rateId}`;
    const res = await axios.patch(url, data);
    return res.data;
}

export const getPrices = async (apartmentId, startDate, endDate) => {
    const url = `/api/v1/user_profile/rms/prices`;
    const res = await axios.get(url, {params: {apartment_id: apartmentId, start_date: startDate, end_date: endDate}});
    return res.data;
}

export const patchPrices = async (rateId, data) => {
    /*
     * Data is an object like this:
     * {
     *  dateFrom: DateISO,
     *  dateTo: DateISO,
     *  enabled: bool,
     *  prices: {
     *      5: int,
     *      6: int,
     *      7: int,
     *      8: int
     *  },
     *  minNights: int,
     *  minPeople: int,
     *  checkin: {
     *      monday: bool,
     *      tuesday: bool,
     *      ...
     *  },
     *  checkout: {
     *      monday: bool,
     *      tuesday: bool,
     *  }
     * }
     * if a field is not present, it is not changed
     */
    const url = `/api/v1/user_profile/rms/rates/${rateId}/prices/bulk_update`;
    const res = await axios.patch(url, data);
    return res.data;
}

export const postPrices = async (rateId, data) => {
    /*
     * Generate price with the AI
     * Data is an object like this:
     * {
     *  dateFrom: DateISO,
     *  dateTo: DateISO,
     *  minPrice: int
     *  maxPrice: int
     *
     *  highSeason: {
     *    minNights: int,
     *    minPeople: int,
     *    checkin: {
     *      monday: bool,
     *      tuesday: bool,
     *      ...
     *    },
     *    checkout: {
     *      monday: bool,
     *      tuesday: bool,
     *      ...
     *  }
     *  midSeason: {
     *      ...
     *  }
     *  lowSeason: {
     *      ...
     *  }
     * }
     *
     */
    const url = `/api/v1/user_profile/rms/rates/${rateId}/prices/bulk_create`;
    const res = await axios.post(url, data);
    return res.data;
}

export const deletePrices = async (rateId) => {
    const url = `/api/v1/user_profile/rms/rates/${rateId}/prices/bulk_destroy`;
    const res = await axios.delete(url);
    return res.data;
}

export const getBookingVariants = async (dateFrom, dateTo, people, petsNumber, homeId) => {
    const url = `/api/v1/user_profile/rms/booking_variants`;
    const res = await axios.get(url, {
        params: {
            date_from: dateFrom,
            date_to: dateTo,
            n_people: people,
            pets_number: petsNumber,
            home_id: homeId
        }
    });
    return res.data;
}

export const getPricesCoverage = async (fromISODate, toISODate) => {
    const url = `/api/v1/user_profile/rms/prices_coverage`;
    const res = await axios.get(url, {params: {
        from_date: fromISODate,
        to_date: toISODate,
        }});
    return res.data;
}